"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressErrorMessages = void 0;
const i18next_1 = __importDefault(require("i18next"));
const errors_1 = require("@/common/errors");
/**
 * @desc DeliverySettingAddress 에러 메시지 \
 * 에러케이스: https://www.notion.so/fondee/ab024a07d373418eb8d4c1ac2603749e?v=aaad38f0563b49ca99bb920e338f6e80&pvs=4
 */
exports.addressErrorMessages = {
    address: {
        required: () => i18next_1.default.t('주소를 입력해주세요'),
        minLength: () => i18next_1.default.t('주소를 10자 이상 입력해주세요'), // ? 40002
    },
    address_detail: () => i18next_1.default.t('상세주소를 입력해주세요'),
    en_address: {
        required: () => i18next_1.default.t('영문 주소를 입력해주세요'),
        minLength: () => i18next_1.default.t('영문 주소를 10자 이상 입력해주세요'), // ? 40006
    },
    en_address_detail: () => i18next_1.default.t('영문 상세주소를 입력해주세요'),
    post_code: {
        required: () => i18next_1.default.t('우편번호를 입력해주세요'),
        minLength: () => i18next_1.default.t('우편번호를 4자 이상 입력해주세요'), // ? 400010
    },
    // ! phone_code: default가 항상 82 이므로 에러 케이스에서 제거, 40011, 40012
    phone: () => i18next_1.default.t('휴대폰 번호를 입력해주세요'),
    name: () => i18next_1.default.t('받는 사람 이름을 입력해주세요'),
    in_progress: () => i18next_1.default.t('요청된 작업이 진행 중이에요!'),
    list_limit: () => i18next_1.default.t('주소는 최대 5개까지 등록할 수 있어요'),
    not_found: () => i18next_1.default.t('이미 삭제된 배송지예요'), // ? 40400
};
const getErrorCodeMessage = (errorCode) => {
    switch (errorCode) {
        case 40001:
            return exports.addressErrorMessages.address.required();
        case 40002:
            return exports.addressErrorMessages.address.minLength();
        case 40003:
        case 40004:
            return exports.addressErrorMessages.address_detail();
        case 40005:
            return exports.addressErrorMessages.en_address.required();
        case 40006:
            return exports.addressErrorMessages.en_address.minLength();
        case 40007:
        case 40008:
            return exports.addressErrorMessages.en_address_detail();
        case 40009:
            return exports.addressErrorMessages.post_code.required();
        case 40010:
            return exports.addressErrorMessages.post_code.minLength();
        // ! case 40011: default 처리
        // ! case 40012: default 처리
        case 40013:
        case 40014:
            return exports.addressErrorMessages.phone();
        case 40015:
        case 40016:
            return exports.addressErrorMessages.name();
        case 40017:
            return exports.addressErrorMessages.in_progress();
        case 40018:
            return exports.addressErrorMessages.list_limit();
        case 40400:
            return exports.addressErrorMessages.not_found();
        // ! unexpected or unknown errors
        case 40011:
        case 40012:
        default:
            return (0, errors_1.commonErrorMsg)(errorCode);
    }
};
/**
 * @desc DeliverySettingAddress의 [POST | PATCH] api 요청  -> 400 error 대응
 * @warning 프론트에서 각 입력값들을 사전에 체크 후 제출(submit)하므로 발생하면 안되는 에러
 * */
function default_1({ confirm, errorCode, concurrenceFn, }) {
    const errorMessage = getErrorCodeMessage(errorCode);
    const isConcurrencyError = errorCode === 40018 || errorCode === 40400;
    confirm({
        description: errorMessage,
        cancellationButtonProps: { style: { display: 'none' } },
        allowClose: !isConcurrencyError,
    })
        .then(() => __awaiter(this, void 0, void 0, function* () { return isConcurrencyError && (yield concurrenceFn()); }))
        .catch(() => { });
}
exports.default = default_1;
